<template>
  <a-card>
    <template slot="title">
      <div style="display: flex;justify-content: space-between">
        <div>{{ $t('editEnterprise') }}</div>
        <div @click="$router.go(-1)"><dol-button><a-icon type="close" /></dol-button></div>
      </div>
    </template>
    <dol-form-model :model="editForm" :rules="validateRules" ref="editForm">
      <dol-row>
        <dol-col style="text-align: center;padding: 0 20px;" :span="12">
          <!--          <a-form-model-item class="company-register-form-item" :colon="false" :labelCol="{span: 24}" :wrapperCol="{span: 24}">-->
          <!--            <template slot="label">-->
          <!--              <span style="font-weight: 600">{{ $t('enterpriseInformation') }}</span>-->
          <!--            </template>-->
          <!--          </a-form-model-item>-->

          <a-form-model-item class="company-register-form-item" :labelCol="{span: 24}" :wrapperCol="{span: 24}"
                             prop="COMPANY_NAME">
            <template slot="label">
              <span>{{ $t('通用_企业名称') }}</span>
            </template>
            <a-input v-model.trim="editForm.COMPANY_NAME" size="large" :placeholder="$t('pleaseEnterCompanyName')" disabled/>
          </a-form-model-item>
          <a-form-model-item class="company-register-form-item" :labelCol="{span: 24}" :wrapperCol="{span: 24}"
                             prop="COMPANY_NAME_RUS">
            <template slot="label">
              <span>{{ $t('nameRus') }}</span>
            </template>
            <a-input v-model.trim="editForm.COMPANY_NAME_RUS" size="large" :placeholder="$t('pleaseEnterCompanyName')"/>
          </a-form-model-item>
          <a-form-model-item class="company-register-form-item" :labelCol="{span: 24}" :wrapperCol="{span: 24}">
            <template slot="label">
              <span>{{ $t('mobile') }}</span>
            </template>
            <a-input v-model.trim="editForm.MOBILE" :placeholder="$t('pleaseEnterMobilePhoneNumber')"  size="large" disabled/>
          </a-form-model-item>
          <a-form-model-item class="company-register-form-item" :labelCol="{span: 24}" :wrapperCol="{span: 24}">
            <template slot="label">
              <span>{{ $t('portOfOffice') }}</span>
            </template>
            <dol-select
                size="large"
                :width="'100%'"
                v-model.trim="editForm.CITY_IDS"
                source="server"
                server-type="DotNet"
                dot-net-table-name="GM_CITY"
                label-field="CITY_NAME"
                key-field="CITY_ID"
                value-field="CITY_ID"
                mode="multiple"
                disabled
            />
          </a-form-model-item>
<!--          <a-form-model-item class="company-register-form-item" :labelCol="{span: 24}" :wrapperCol="{span: 24}">-->
<!--            <template slot="label">-->
<!--              <span>{{ $t('gratisUseBoxDay') }}</span>-->
<!--            </template>-->
<!--            <a-input-number v-model.trim="editForm.FREE_USE_DAYS" :placeholder="$t('pleaseEnterTheNumberOfFreeDays')" size="large"/>-->
<!--          </a-form-model-item>-->
          <a-form-model-item class="company-register-form-item" :labelCol="{span: 24}" :wrapperCol="{span: 24}">
            <template slot="label">
              <span>{{ $t('businessLicense') }}</span>
            </template>
            <div v-for="(item,index) in imgList" :key="index">
              <div v-if="fileTypeList.indexOf(item.FILE_TYPE.toLowerCase()) !== -1">
                <dol-image-list-preview :imageList="[item]"></dol-image-list-preview>
              </div>
              <a :href="$Dolphin.path.filePath+item.FILE_NAME" target="_blank" v-else>
                {{ item.ORGI_FILE_NAME }}
              </a>
            </div>
            <!--            <dol-image-list-preview :imageList="imgList"/>-->
          </a-form-model-item>
        </dol-col>
        <dol-col style="padding: 0 20px;" :span="12">
          <a-form-model-item class="company-register-form-item" :labelCol="{span: 24}" :wrapperCol="{span: 24}"
                             prop="COMPANY_NAME_ENG">
            <template slot="label">
              <span>{{ $t('nameEng') }}</span>
            </template>
            <a-input v-model.trim="editForm.COMPANY_NAME_ENG" size="large" :placeholder="$t('pleaseEnterCompanyName')"/>
          </a-form-model-item>
          <a-form-model-item class="company-register-form-item" :labelCol="{span: 24}" :wrapperCol="{span: 24}">
            <template slot="label">
              <span>{{ $t('contact') }}</span>
            </template>
            <a-input v-model.trim="editForm.PERSON" :placeholder="$t('pleaseEnterTheContactPerson')" size="large" disabled/>
          </a-form-model-item>
          <a-form-model-item class="company-register-form-item" :labelCol="{span: 24}" :wrapperCol="{span: 24}">
            <template slot="label">
              <span>{{ $t('businessAddressDetails') }}</span>
            </template>
            <a-input v-model.trim="editForm.ADDRESS" :placeholder="$t('pleaseEnterTheDetailedAddressOfTheEnterprise')"  size="large" disabled/>
            <!--            <dol-select :width="'100%'" size="large" v-model.trim:lue="editForm.username"/>-->
          </a-form-model-item>
          <a-form-model-item class="company-register-form-item" :labelCol="{span: 24}" :wrapperCol="{span: 24}">
            <template slot="label">
              <span>{{ $t('email') }}</span>
            </template>
            <a-input v-model.trim="editForm.EMAIL" :placeholder="$t('pleaseEnterEmailAddress')"  size="large" disabled/>
          </a-form-model-item>
<!--          <a-form-model-item class="company-register-form-item" :labelCol="{span: 24}" :wrapperCol="{span: 24}">-->
<!--            <template slot="label">-->
<!--              <span>{{ $t('currency') }}</span>-->
<!--            </template>-->
<!--            <dol-select-->
<!--                v-model.trim="editForm.CURRENCY_ID"-->
<!--                source="server"-->
<!--                server-type="DotNet"-->
<!--                style="width: 100%"-->
<!--                dot-net-table-name="GM_CURRENCY"-->
<!--                :label-field="$kt('CURRENCY_NAME')"-->
<!--                :key-field="$kt('CURRENCY_NAME')"-->
<!--                value-field="CURRENCY_ID"-->
<!--                size="large"-->
<!--            />-->
<!--          </a-form-model-item>-->
        </dol-col>
      </dol-row>
      <div style="text-align: center;margin-top: 24px;">
        <a-button type="primary" style="background: #1F6CBA;width: 150px"  @click="updateCompany"
                  block size="large">{{ $t('save') }}
        </a-button>
      </div>
    </dol-form-model>
  </a-card>
</template>

<script>

export default {
  name: "enterprise",
  data() {
    return {
      fileTypeList: ['.png', '.jpg', '.jpeg', '.bmp', '.gif', '.webp', '.psd', '.svg', '.tiff'],
      editForm: {},
      paramsData:{},
      imgList:[],
      validateRules: {
      },
    }
  },
  computed: {
    userInfo() {
      return this.$store?.state?.userInfo;
    },
    sysType(){
      let type='' ;
      this.$store?.state?.sysList?.forEach(item=>{
        if(item.SYS_CODE === 20011003 ){
          type=item
        }
      })
      return type
    },
  },
  methods: {
    updateCompany() {
      let data ={};
      data.SYS_TYPE = 20011003;
      data.COMPANY_ID = this.userInfo.COMPANY_ID;
      data.COMPANY_NAME_RUS = this.editForm.COMPANY_NAME_RUS;
      data.COMPANY_NAME_ENG = this.editForm.COMPANY_NAME_ENG;
      data.CURRENCY_ID = this.editForm.CURRENCY_ID;
      data.FREE_USE_DAYS = this.editForm?.FREE_USE_DAYS,
      this.$h5Api({
        type: '2013',
        data: [data],
        showMessage: false,
      }).then(({data, total}) => {
        this.$store.commit('afterLogin', data);
        this.$router.push('company')
      })
    },
    finished(){}
  },
  created() {
    this.editForm = {
      COMPANY_ID : this.userInfo?.COMPANY_ID,
      COMPANY_NAME : this.userInfo?.COMPANY_NAME,
      COMPANY_NAME_ENG : this.userInfo?.COMPANY_NAME_ENG,
      COMPANY_NAME_RUS : this.userInfo?.COMPANY_NAME_RUS,
      PERSON : this.userInfo?.PERSON,
      MOBILE : this.userInfo?.MOBILE,
      ADDRESS : this.userInfo?.ADDRESS,
      EMAIL : this.userInfo?.EMAIL,
      ACCT_BANK : this.userInfo?.ACCT_BANK,
      ACCT_ADDRESS : this.userInfo?.ACCT_ADDRESS,
      ACCT_NO : this.userInfo?.ACCT_NO,
      CURRENCY_ID : this.userInfo?.CURRENCY_ID,
      ACCT_NO2 : this.userInfo?.ACCT_NO2,
      ACCT_NO3 : this.userInfo?.ACCT_NO3,
      ACCT_PHONE : this.userInfo?.ACCT_PHONE,
      SWIFT_CODE : this.userInfo?.SWIFT_CODE,
      FREE_USE_DAYS : this.userInfo?.FREE_USE_DAYS,
    }
    if(this.$store.state.fileList){
      this.imgList = this.$store.state.fileList;
    }
    let list = [];
    if(this.userInfo.cityList.length > 0) {
      this.userInfo.cityList.forEach(item => {
        list.push(item.CITY_ID)
      })
    }
    this.$set(this.editForm,'CITY_IDS',list)
  }
}
</script>

<style scoped lang="scss">
.acct-bank-style{
  display: flex;
  justify-content: flex-end;
  .acct-bank-style-span{
    margin-right: 8px;
    color: rgba(0, 0, 0, 0.85);
  }

+ .acct-bank-style{
    margin-top: 24px;

  }
}

</style>